module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_email-dfa624ab84ea3a94a18f95d90c11f576.jpg";